
    $(document).ready(function() {

        $('#passcodeMethod').on('show.bs.modal', function () {
            $('#passcode').val('');
            $('#passcode-email').val('');
        });

        $('#validationMethod').on('show.bs.modal', function () {
            $('.validate-email-error').html('').addClass('d-none');
            $('#validate_email').removeClass('is-invalid');
            $('.email-input').removeClass('d-none');
            $('.validate').addClass('d-none');
            $('#validate_email').val('');
            $('.validation-string').each(function() {
                $(this).val('');
            });
            $('.validate-code-error').html('').addClass('d-none');
            $('.btn-verify').attr('disabled', 'disabled');
            $('#validate_email').focus();
        });

        $('.btn-send-email').click(function() {

            let sendMailButton = $(this),
                sendMailButtonText = sendMailButton.html();

            $('.page-loading').show();
            $('.validate-email-error').html('').addClass('d-none');
            $('#validate_email').removeClass('is-invalid');

            sendMailButton.attr('disabled', 'disabled').html('Processing...');
            $.post('/verification-code', { organization: $('input[name="organization"]').val(),
                product: $('input[name="product"]').val(),
                username: $('#validate_email').val() }, function() {

                    sendMailButton.removeAttr('disabled').html(sendMailButtonText);
                    $('.email-input').addClass('d-none');
                    $('.validate').removeClass('d-none');
                    $('input[name="validation_string[]"').first().focus();
                    $('.page-loading').hide();

            })
            .fail(function(xhr) {

                let message = xhr.responseJSON.message == 'The given data was invalid.' ? 'Please input username.' : xhr.responseJSON.message;
                if(xhr.responseJSON.message == 'The given data was invalid.')
                {
                    $('#validate_email').addClass('is-invalid');
                }
                $('.validate-email-error').html(message).removeClass('d-none');
                sendMailButton.removeAttr('disabled').html(sendMailButtonText);
                $('.page-loading').hide();

            });
        });

        $('.btn-verify').click(function() {

            let code = '',
                verifyButton = $(this),
                verifyButtonText = verifyButton.html();

            if($(this).attr('data-preview') == 'true')
            {
                return ;
            }

            $('.validation-string').each(function() {
                code = code + $(this).val();
            });

            $('.validate-code-error').html('').addClass('d-none');
            verifyButton.attr('disabled', 'disabled').html('Verifying...');

            $.post('/verification-code/code', { organization: $('input[name="organization"]').val(),
                                                product: $('input[name="product"]').val(),
                                                code: code }, function() {

                window.location.reload();
            })
            .fail(function(xhr) {

                $('.validate-code-error').html(xhr.responseJSON.message).removeClass('d-none');
                verifyButton.removeAttr('disabled').html(verifyButtonText);

            });

        });

        var charLimit = 1;
        var moveAlong = false;

        $('.validation-string').on('keydown', function(e) {

            if (e.which > 31 && (e.which < 48 || e.which > 57)) {
                return false;
            }

            moveAlong = true;
            return true;

        }).on('keyup', function(e) {

            let $input = $(this);

            if(checkValidationString())
            {
                $('.btn-verify').removeAttr('disabled');
            } else {
                $('.btn-verify').attr('disabled', 'disabled');
            }

            if(moveAlong === true) {
                if (e.which == 8 && this.value.length == 0) {
                    $input.prev('.validation-string').focus();
                } else if (this.value.length >= charLimit) {
                    $input.next('.validation-string').focus();
                    moveAlong = false;
                    return false;
                }

                if ($input.val().length == 0 && e.which == 8) {
                    $input.prev('.validation-string').focus();
                } else {
                    $input.next('.validation-string').focus();
                }
            }

            moveAlong = false;

        });

        function checkValidationString()
        {
            var isValid = true;
            $('.validation-string').each(function() {
                if($(this).val() === ''){
                    isValid = false;
                    return false;
                }
            });
            return isValid;
        }

        $('.validation-string').on("paste", function() {
            var $this = $(this),
                originalValue = $this.val(),
                $inputs = $(".verification-code"),
                intRegex = /^\d+$/;

            $this.val('');

            $this.one("input.fromPaste", function(){
                var $currentInputBox = $(this);

                var pastedValue = $currentInputBox.val();

                if (pastedValue.length == 8 && intRegex.test(pastedValue)) {
                    pasteValues(pastedValue);
                    $('.validation-string').eq(7).focus();
                }
                else {
                    $this.val(originalValue);
                }

                $inputs.attr("maxlength", 1);
            });

            $inputs.attr("maxlength", 8);
        });

        function pasteValues(element) {
            var values = element.split("");
            $(values).each(function (index) {
                console.log(index);
                var $inputBox = $('.validation-string').eq(index);
                $inputBox.val(values[index])
            });
        }

        $('.btn-check-passcode').click(function() {

            var passcode = $('#passcode').val(),
                email = $('#passcode-email').val();

            $('.validate-passcode-code-error').addClass('d-none');

            $.post('/verify-passcode', { organization: $('input[name="organization"]').val(),
                product: $('input[name="product"]').val(), email: email, passcode: passcode }, function() {
                window.location.reload();
            }).fail(function(xhr) {
                $('.validate-passcode-code-error').html(xhr.responseJSON.message).removeClass('d-none');
            });

        });

    });

